import { Injectable } from '@angular/core';
import { ApiClientService } from '../../shared/services/api-client.service';
import { HttpClient } from '@angular/common/http';
import { AB_API_TRANSFERS_GETBANKSBYCOUNTRY } from '../../shared/constants';
import { Observable, ReplaySubject } from 'rxjs';

interface IBankInfo {
  id: string;
  abaCode: string;
  bicCode: string;
  branchCode: string;
  name: string;
  branch: string;
  address: string;
  postCode: string;
  city: string;
  countryCode: string;
  country: string;
}

@Injectable({
  providedIn: 'root'
})
export class BankService extends ApiClientService {
  private cache: { [name: string]: ReplaySubject<IBankInfo[]> } = {};
  constructor(http: HttpClient) {
    super(http, AB_API_TRANSFERS_GETBANKSBYCOUNTRY);
  }

  public getBankByCountry(): Observable<IBankInfo[]> {
    if (!this.cache['bankList']) {
      this.cache['bankList'] = new ReplaySubject<IBankInfo[]>();
      this._getBankByCountry().subscribe(response => {
        this.cache['bankList'].next(response);
      });
    }

    return this.cache['bankList'].asObservable();
  }

  private _getBankByCountry() {
    return this.get();
  }
}

export { IBankInfo };
